function _clickElement(el) {
  el.click();
}
export function focusOnTemporaryInput() {
  const tempInput = document.createElement('input');
  tempInput.setAttribute('type', 'text');
  tempInput.style.position = 'absolute';
  tempInput.style.opacity = '0';
  tempInput.style.height = '0';
  tempInput.readOnly = true;
  tempInput.style.fontSize = '16px'; // disable auto zoom
  document.body.prepend(tempInput);
  tempInput.focus();
  return tempInput;
}
export const domMocks = {
  clickElement(el) {
    return _clickElement(el);
  }
};
export function clickElement(el) {
  return domMocks.clickElement(el);
}